// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__bI_Bf","content":"LayoutSettings_content__DZvDI"};